var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"info"}},[_vm._v(" Your current permission level for this submission does not allow editing of this page. Contact the submission author to request a change in permission level. ")])}
var staticRenderFns = []

export { render, staticRenderFns }